import { getJobStatus, submitClusterJob } from '@/api/cluster.js'

export const generateDisclosureLandscape = async (
    disclosureId,
    description,
    micsCodes,
    keywords,
    numClusters
) => {
    const clusterJob = {
        cluster_strategy: 'adaptive',
        source_type: 'patent',
        vectors: [
            {
                vector_type: 'patent_cpc_512',
                configuration: {
                    max_cluster_size: -1,
                    min_cluster_size: 2,
                    min_num_clusters: numClusters,
                    max_num_clusters: numClusters + 1,
                    seed_expansion_config: {
                        strategies: ['mics', 'similarity'],
                        max_patents: 1000,
                        source_patent_id: disclosureId,
                        similarity_threshold: 0.85,
                        patent_status: 'Active',
                        patent_jurisdiction: 'US',
                    },
                },
            },
        ],
        use_openai_labels: true,
    }

    const clusterData = {
        ids: [disclosureId],
        virtual_patents: [
            {
                patent_id: disclosureId,
                title: '',
                keywords: keywords,
                text: description,
                mics_codes: micsCodes,
            },
        ],
    }

    const job_id = await submitClusterJob(clusterJob, clusterData)
    await getJobResult(job_id)

    return job_id
}

const getJobResult = async (jobId) => {
    let pollCount = 0

    async function pollJobResults() {
        const response = await getJobStatus(jobId)

        if (response.status !== 200) {
            throw new Error(
                `Failed to get analysis result: StatusCode: ${response.status}; Message: ${response.data?.message}`
            )
        }

        if (['SUCCESS', 'FAILURE'].includes(response.data.status)) {
            return response.data
        }

        pollCount++
        if (pollCount < 20) {
            await new Promise((resolve) => setTimeout(resolve, 5000))
            return pollJobResults()
        }
    }

    return await pollJobResults()
}
